import { connect } from 'react-redux';
import GerarBoletoCnab from './gerarBoletoCnab';

export default connect()(GerarBoletoCnab);
